import userflow from 'userflow.js';

import { isProd } from '../config/config';
import { USER_FLOW_TOKEN } from '../config/userflow-config';
import { getHistory } from '../widgets/browser-history-spy';

export const USER_FLOW_IDS = {
  DASHBOARD_PHASE1_HIRING: '2a05f8b1-ab47-413d-872d-e3f06853ea84',
  DASHBOARD_PHASE1_EMPLOYEE: 'dc515602-b36a-496d-94f7-90cb5ed9c0b1',
};

export class UserflowController {
  static init = async (u: AuthenticatedUser) => {
    // Disabling this outside of production because it's causing end to end tests to fail.
    // Comment this out to test any new User Flows
    if (!isProd) {
      return;
    }
    if (!USER_FLOW_TOKEN) {
      throw new Error('Missing environment Userflow.js token');
    }
    userflow.init(USER_FLOW_TOKEN);

    // TODO (?) - add feature gates to user identify
    // Keep in mind, if we add any attributes here that aren't in the normalized user, it is most likely worth adding them to the normalized user

    // User identify attributes are all optional and used to both identify users and identify if users should start flows
    // https://userflow.com/docs/userflow-js#identify - https://userflow.com/docs/userflow-js#attributes
    await userflow.identify(u.username, {
      name: `${u.firstName} ${u.lastName}`,
      email: u.email,
      hiringPermission: u.hiringPermission,
      employeePermission: u.employeesPermission,
    });

    if (!isProd) {
      // eslint-disable-next-line no-console
      console.log('[Userflow] User identified');
    }

    // Userflow allows you to navigate users to new URLs - Since we are using a SPA, it's better to navigate via "history.push"
    // It is recommended to set custom navigate if you navigate with history https://userflow.com/docs/userflow-js#setcustomnavigate
    const history = getHistory();
    userflow.setCustomNavigate((url) => history.push(url));
  };

  static reset = () => {
    // recommended to do when the user logs out https://userflow.com/docs/userflow-js#reset
    userflow.reset();
  };

  static beginUserFlow = async (flowId: string) => {
    await userflow.start(flowId);
  };
}
